import type { TOC } from '@ember/component/template-only';

import DataManagerMergedDatasetsComponent from 'webapp/components/data-manager/merged-datasets';

const DatamanagerMergedDatasetsRouteTemplate: TOC<object> = <template>
	<DataManagerMergedDatasetsComponent />
</template>;

export default DatamanagerMergedDatasetsRouteTemplate;
